import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { RecoverCredentialPayload, RecoveredCredentialData } from './recover-auth-credential.types';

// deprecated service ref.: recoverService_DEPRECATED
export async function recoverCredentialService({ body }: RecoverCredentialPayload) {
  const { response, data } = await BACKEND.post<RecoveredCredentialData>(ENDPOINT.RECOVER, { body });

  return {
    response,
    summary: data,
  };
}
